import { useState, useEffect, useRef, useMemo } from "react";
import TablaMRT from "../../features/table/RTable";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import Anadir from "../../assets/img/svg/projects/anadir.svg";
import "../providers/InstallersDocuments.css";
import {
  buscarTrabajosProyectos,
  eliminarProyecto,
  buscarTrabajosProyectosAgrupados,
} from "../functions/Projects";
import { useNavigate } from "react-router-dom";
import Popper from "@mui/material/Popper";
import {
  capitalize,
  highlightText,
  formatEmpresa,
} from "../../utils/functionsFormat";
import {
  headCellLeftAlign,
  headCellCenterAlign,
} from "../../utils/columnStyles";
import { customStringFilter } from "../../features/table/filterFunctions";
import { ClickAwayListener } from "@mui/material";
import "./WorkCenter.responsive.css";
import Card from "../../features/cards/CardsGraph";
import Buscar from "../../assets/img/svg/buscar.svg";
import CustomButton from "../../ui/button/Button";
import ProjectFilterModal from "../../features/projectFilterModal/ProjectFilterModal";
import { defaultCriteriosWithId } from "../../constants/projects";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import Eliminar from "../../assets/img/svg/documents/eliminar.svg";
import EditProjectModal from "../../features/editProjectModal/EditProjectModal";
import {
  fetchTipoReportes,
  fetchUsuariosHabilitadosPM,
} from "../../components/functions/Projects";

const WorkCenter = ({
  API_URL,
  page = false,
  clients,
  permisionarios,
  projects,
  companies,
  states,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState(null);
  const [criterios, setCriterios] = useState(defaultCriteriosWithId);
  const [showModal, setShowModal] = useState(false);

  const [showEditProjectModal, setShowEditProjectModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [tipoReportes, setTipoReportes] = useState([]);
  const [usuariosHabilitadosPM, setUsuariosHabilitadosPM] = useState([]);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const [data, setData] = useState([]);
  const [filteredBase, setFilteredBase] = useState([]);
  const sortedData = useMemo(() => {
    return [...filteredBase].sort((a, b) => {
      const valorA = (a?.cliente?.razonSocial || "").toLowerCase();
      const valorB = (b?.cliente?.razonSocial || "").toLowerCase();
      return valorA.localeCompare(valorB); // DESC
    });
  }, [filteredBase]);
  const [openMenuIndex, setOpenMenuIndex] = useState({ top: 0, left: 0 }); // Estado para el menú desplegable

  const showDialog = useConfirmDialog();

  const opcionesEstadisticas = [
    { value: null, name: "Todos" },
    { value: "Concluido", name: "Proyectos concluidos" },
    { value: "En proceso", name: "Proyectos en ejecución" },
    { value: "Inactivo", name: "Proyectos inactivos" },
  ];

  const editarProyecto = async (data) => {
    const project = projects.find((p) => p.id === data.id);
    if (project) {
      setSelectedProject(project);
      setShowEditProjectModal(true);
    }
  };

  useEffect(() => {
    fetchTipoReportes(API_URL, setTipoReportes);
    fetchUsuariosHabilitadosPM(API_URL, setUsuariosHabilitadosPM);
  }, [API_URL]);

  const handleCloseEditProjectModal = () => {
    setShowEditProjectModal(false);
    setSelectedProject(null);
  };

  const handleConfirmEditProject = (success, project) => {
    handleCloseEditProjectModal();

    if (success) {
      const newProjects = data.filter((p) => p.id !== project.id);
      newProjects.push(project);
      newProjects.sort((a, b) => a.nombre.localeCompare(b.nombre));
      setData(newProjects);
      showDialog({
        html: "Proyecto editado exitosamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
    } else {
      showDialog({
        html: "Error al editar el proyecto.",
        icon: "error",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
    }
  };

  const crearCentroDeTrabajo = async (id) => {
    navigate(`/proyectos/nuevo?proyecto=${id}`);
  };

  const handleEliminarProyecto = async (rowData) => {
    showDialog({
      html: `
      <p class="text-dialog">
        ¿Estás seguro de que deseas eliminar este proyecto?<br/>
        Esta acción no se puede deshacer.
      </p>
    `,
      icon: "warning",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
      mostrarCancelar: true,
      onConfirm: async () => {
        try {
          const proyectoId = rowData?.proyecto?.id || rowData?.id;

          await eliminarProyecto(API_URL, proyectoId);

          // Quitar el proyecto de la tabla
          setData((prev) =>
            prev.filter(
              (item) => (item.proyecto?.id || item.id) !== proyectoId,
            ),
          );

          // Mensaje de éxito
          showDialog({
            html: "Proyecto eliminado exitosamente.",
            icon: "success",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
        } catch (error) {
          showDialog({
            html: "Error al eliminar proyecto.",
            icon: "error",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
        } finally {
          setOpenMenuIndex(null);
        }
      },
    });
  };

  const countByStatus = (status, base) =>
    base.filter((item) =>
      item.estatusLista?.some((e) => e.toLowerCase() === status.toLowerCase()),
    ).length;

  const calculateStatusProgress = (status, base) => {
    const total = base.length;
    const count = countByStatus(status, base);
    return total > 0 ? Math.round((count / total) * 100) : 0;
  };

  useEffect(() => {
    setIsLoading(true);

    buscarTrabajosProyectosAgrupados(
      API_URL,
      criterios,
      (resultados) => {
        setData(resultados);
        setIsLoading(false);
      },
      (errorMsg) => {
        console.log(errorMsg);
        setIsLoading(false);
      },
    );
  }, [criterios]);

  const obtenerNombreCliente = (id) => {
    const cliente = clients?.find((c) => c.id === id);
    return cliente ? cliente.razonSocial : " - ";
  };

  const obtenerNombrePermisionario = (id) => {
    const perm = permisionarios?.find((p) => p.id === id);
    console.log(perm, "es perm");
    return perm ? perm.razonSocial : " - ";
  };

  useEffect(() => {
    if (!statusFilter) {
      setFilteredBase(data);
      return;
    }

    const statusLower = statusFilter.toLowerCase();

    const filtrados = data.filter((item) =>
      item.estatusLista?.some(
        (nombre) => nombre?.toLowerCase() === statusLower,
      ),
    );

    setFilteredBase(filtrados);
  }, [statusFilter, data]);

  const rowIconRef = useRef([]); // Ref único para cada fila
  const toggleMenuOptions = (index) => {
    setOpenMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const columns = [
    {
      accessorKey: "proyecto.nombre",
      header: "Proyecto",
      filterFn: customStringFilter,
      width: 130,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row, table }) => {
        const nombre = row.original.proyecto
          ? row.original.proyecto?.nombre
          : row.original.nombre || " - ";
        const filter = table?.getState().globalFilter;
        return highlightText(capitalize(nombre), filter);
      },
    },
    {
      accessorKey: "cliente.contractual",
      header: "Cliente contractural",
      filterFn: customStringFilter,
      width: 130,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row, table }) => {
        const nombre = row.original?.clienteContractual || " - ";
        const filter = table?.getState().globalFilter;
        return highlightText(formatEmpresa(nombre), filter);
      },
    },
    {
      accessorKey: "totalTrabajos",
      header: "Centros de carga",
      filterFn: customStringFilter,
      width: 150,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row }) => row.original?.totalTrabajos || 0,
    },
    {
      accessorKey: "permisionario",
      header: "Permisionario",
      filterFn: customStringFilter,
      width: 150,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row, table }) => {
        const nombre =
          row.original?.permisionario?.razonSocial ||
          obtenerNombrePermisionario(row?.original?.permisionarioId);
        const filter = table?.getState().globalFilter;
        return highlightText(formatEmpresa(nombre), filter);
      },
    },
    {
      accessorKey: "cliente.razonSocial",
      header: "Usuario final",
      filterFn: customStringFilter,
      width: 130,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row, table }) => {
        const nombre =
          row.original.cliente?.razonSocial ||
          obtenerNombreCliente(row?.original?.clienteId);
        const filter = table?.getState().globalFilter;
        return highlightText(formatEmpresa(nombre), filter);
      },
    },
    {
      accessorKey: "usuarioPM",
      header: "PM",
      filterFn: customStringFilter,
      width: 130,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row, table }) => {
        const nombre = row?.original?.usuarioPM?.nombre || " - ";
        const filter = table?.getState().globalFilter;
        return highlightText(capitalize(nombre), filter);
      },
    },

    {
      id: "options",
      header: " ",
      width: 50,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ row }) => {
        const rowData = row.original;
        const anchorRef = useRef(null);
        const isOpen = openMenuIndex === row.index;
        return (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <button
              ref={(el) => (rowIconRef.current[row.index] = el)}
              onClick={() => toggleMenuOptions(row.index)}
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <Popper
              open={openMenuIndex === row.index}
              anchorEl={rowIconRef.current[row.index]}
              placement="bottom-start"
              style={{ zIndex: 999 }}
            >
              <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
                <div
                  className="dropdown-menu-user"
                  style={{
                    background: "white",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    padding: "8px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                >
                  <p
                    onClick={() => {
                      if (rowData.proyecto && rowData.proyecto.id) {
                        editarProyecto(rowData.proyecto);
                      } else {
                        editarProyecto(rowData);
                      }
                    }}
                    style={{ cursor: "pointer", margin: 0 }}
                  >
                    <img src={Editar} alt="" style={{ marginRight: "8px" }} />
                    Editar proyecto
                  </p>
                  <p
                    onClick={() => handleEliminarProyecto(rowData)}
                    style={{ cursor: "pointer", margin: 0 }}
                  >
                    <img src={Eliminar} alt="" style={{ marginRight: "8px" }} />
                    Eliminar proyecto
                  </p>
                  <p
                    onClick={() => {
                      if (rowData.tipoTrabajo) {
                        navigate(
                          `/proyectos/editar/${rowData.id}?newWorkCenter=true`,
                        );
                      } else {
                        crearCentroDeTrabajo(rowData.id);
                      }
                    }}
                    style={{ cursor: "pointer", margin: 0 }}
                  >
                    <img src={Anadir} alt="" style={{ marginRight: "8px" }} />
                    Crear centro de carga
                  </p>
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
  ];

  const options = {
    enableColumnFilters: false,
    enableSorting: true,
    enablePagination: true,
  };

  const handleStatusCardClick = (status) => {
    setStatusFilter(status);
  };

  return (
    <div className="wc-container" style={{ display: "flex", height: "100%" }}>
      <div
        className="wc-content"
        style={{ flex: 1, padding: "10px", width: "calc(100% - 12rem)" }}
      >
        <div
          className="wc-header"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "30px",
            marginBottom: "10px",
          }}
        >
          <h3
            style={{
              color: "#223D51",
              fontWeight: "700",
              fontSize: "18px",
              margin: 0,
            }}
          >
            Proyectos
          </h3>
          {page && (
            <CustomButton
              background={"#FFFFFF"}
              width={"160px"}
              height={"31px"}
              fontSize={"14px"}
              color={"#223D51"}
              text={"Filtros Avanzados"}
              fontWeight={700}
              fontStyle={"normal"}
              border={"0.5px solid #C3C3C3"}
              icon={true}
              src={Buscar}
              iconW={"12px"}
              iconM={"5px"}
              onClick={handleOpenModal}
            />
          )}
        </div>
        {page && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "16px",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            <div style={{ display: "flex", gap: "20px" }}>
              {opcionesEstadisticas.map((opcion) => (
                <Card
                  key={opcion.value ?? "todos"}
                  status={opcion.name}
                  count={
                    opcion.value === null
                      ? data.length
                      : countByStatus(opcion.value, data)
                  }
                  progress={
                    opcion.value === null
                      ? undefined // No mostrar círculo para "Todos"
                      : calculateStatusProgress(opcion.value, data)
                  }
                  color={
                    opcion.value === "En proceso"
                      ? "orange"
                      : opcion.value === "Concluido"
                        ? "green"
                        : opcion.value === "Activo"
                          ? "blue"
                          : undefined
                  }
                  onClick={() => handleStatusCardClick(opcion.value)}
                  style={{
                    boxShadow:
                      statusFilter === opcion.value
                        ? "0 5px 15px rgba(0, 0, 0, 0.35)"
                        : "none",
                  }}
                />
              ))}
            </div>
          </div>
        )}

        <div className="wc-tableWrap">
          <TablaMRT columns={columns} data={sortedData} options={options} />
        </div>
      </div>
      <EditProjectModal
        API_URL={API_URL}
        open={showEditProjectModal}
        onClose={handleCloseEditProjectModal}
        onConfirm={handleConfirmEditProject}
        proyecto={selectedProject}
        tipoReportes={tipoReportes}
        usuariosHabilitadosPM={usuariosHabilitadosPM}
      />
      <ProjectFilterModal
        states={states}
        companies={companies}
        projects={projects}
        clients={clients}
        permisionarios={permisionarios}
        handleCloseModal={handleCloseModal}
        showModal={showModal}
        criterios={criterios}
        setCriterios={setCriterios}
      />
    </div>
  );
};

export default WorkCenter;
